<template>
  <span :class="computedClass">{{ LEAVE_STATUS_TEXT[status] }}</span>
</template>

<script>
import { LEAVE_STATUS, LEAVE_STATUS_TEXT } from '@/utils/constUtils'
export default {
  name: 'commonLeaveStatus',
  components: {},
  props: {
    border: {
      type: Boolean, // 是否需要边框
      default: false
    },
    status: [String, Number] // 请假状态
  },
  data() {
    return {
      LEAVE_STATUS: LEAVE_STATUS,
      LEAVE_STATUS_TEXT: LEAVE_STATUS_TEXT
    }
  },
  computed: {
    computedClass() {
      let _result = ''

      switch (this.status) {
        // 待审批/待撤销
        case LEAVE_STATUS.toBeChecked:
        case LEAVE_STATUS.toBeCancel:
          _result = this.border ? 'leave-status-checking border-checking' : 'leave-status-checking'
          break
        // 已同意
        case LEAVE_STATUS.agreed:
        case LEAVE_STATUS.cancelRejected:
          _result = this.border ? 'leave-status-agreed border-agreed' : 'leave-status-agreed'
          break
        // 已拒绝/拒绝撤销
        case LEAVE_STATUS.rejected:
          _result = this.border ? 'leave-status-rejected border-rejected' : 'leave-status-rejected'
          break
        // 已撤销
        case LEAVE_STATUS.canceled:
          _result = this.border ? 'leave-status-canceled border-canceled' : 'leave-status-canceled'
          break
        default:
          break
      }

      return _result
    }
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {},
  filters: {}
}
</script>

<style lang="scss" scoped>
.leave-status-checking {
  color: #ff943e;
}
.leave-status-agreed {
  color: #15bc83;
}
.leave-status-rejected {
  color: #f25643;
}
.leave-status-canceled {
  color: #474d51;
}
.border-checking{
  border: 1px solid rgb(255, 148, 62, 0.5);
  padding: 3px 6px;
  border-radius: 4px;
}
.border-agreed{
  border: 1px solid rgb(21, 188, 131, 0.5);
  padding: 3px 6px;
  border-radius: 4px;
}
.border-rejected{
  border: 1px solid rgb(242, 86, 67, 0.5);
  padding: 3px 6px;
  border-radius: 4px;
}
.border-canceled{
  border: 1px solid rgb(71, 77, 81, 0.5);
  padding: 3px 6px;
  border-radius: 4px;
}
</style>
